<script>
	import { scaleAdOnHover, startAd, stopAd } from '../../../../share/ads';
	import { onMount } from 'svelte';
	import { getText, jumpByAnchor } from '../../../../share/utils';

	let ads = {
		// Social_Ad_Schaefer_5_K
		brotVideo: {
			element: false,
			fallbackImgUrl: './../video/Social_Ad_Schaefer_5_K.webp',
			imageAltText: 'Riesa - interactive Ad',
			videoUrl: './../video/Social_Ad_Schaefer_5_K.mp4',
			playTimeMs: 11000,
			maxScale: 1,
			playing: false,
			volume: 0,
			autoStopTimeOut: false,
			pauseImgOffsetS: 4
		}
	}

	let div;

	onMount(() => {
		jumpByAnchor(div);
	});
</script>

<div bind:this={div} id="schaefers_backstube">
	<div class="flex structure marginbox">
		<div class="flex row structure-1">
			<div class="flex element">
				<img loading="lazy" alt="Werbeposter Schäfers Backstube"
					 src="./../img/10.Appetit_Digitalisieren/09.content_king/pflaume.webp">
			</div>
			<div class="flex element align_right">
				<img loading="lazy" alt="Werbemittel Schäfers Backstube"
					 src="./../img/10.Appetit_Digitalisieren/09.content_king/schaefers_oktobergaudi.webp">
			</div>
			<div class="flex element">
				<div class="text">
					<h2 class="caption">{getText("10.09.01_h2")}</h2>
					<p class="caption">{getText("10.09.02_caption")}</p>
					<p class="caption blue">Project Lead: <a href="//www.dschoy.de" target="_blank">Dschoy</a></p>
				</div>
			</div>
		</div>
		
		<div class="flex row structure-2">
			<div class="flex element">
				<img loading="lazy" alt="Werbebanner Schäfers Backstube"
					 src="./../img/10.Appetit_Digitalisieren/09.content_king/schaefers_kulturangebrot.webp">
			</div>
			
			<!-- Beginning - brotVideo -->
			<div bind:this={ads.brotVideo.element} class="content">
				<div use:scaleAdOnHover={ads.brotVideo} class="commercial" class:playing={ads.brotVideo.playing} on:click={() =>
				!ads.brotVideo.playing ? startAd(ads.brotVideo, () => ads = ads) : null}>
					<video playsinline loop="true" on:loadeddata={() => stopAd(ads, ads.brotVideo, () => ads = ads)} scrolling="no"
						   src={ads.brotVideo.videoUrl}/>
					{#if ads.brotVideo.playing}
						<!-- PLAYING -->
					{:else}
						<!-- NOT PLAYING -->
						<button aria-label="play Ad - {ads.brotVideo.imageAltText}" class="playbutton"></button>
					{/if}
				</div>
			</div>
			<!-- End - brotVideo -->
		
		</div>
	</div>
</div>

<style lang="scss">
	@import "../../../../style/mixins";
	@import "../../../../style/variables";
	
	div {
		width: 100%
	}
	
	img {
		width: 100%;
		margin: 0;
		padding: 0;
	}
	
	.flex {
		display: flex;
		box-sizing: border-box;
	}
	
	.row {
		flex-flow: row wrap;
	}
	
	.col {
		flex-flow: column wrap;
	}
	
	.element {
		min-width: 100px;
		align-self: center;
	}
	
	.commercial {
		position: relative;
		width: 100%;
		height: 100%;
	}
	
	.content {
		flex: 1 100%;
	}
	
	.structure {
		flex-flow: row wrap;
		
		@include for-tablet-portrait-up {
			flex-flow: row nowrap;
		}
	}
	
	.structure-1 {
		width: auto;
		flex-direction: column;

		@include for-tablet-portrait-up {
			width: 60%;
			margin-right: $media-gap;
		}
	}
	
	.structure-2 {
		margin-bottom: $spacing-mobile;
		align-content: baseline;

		@include for-tablet-portrait-up {
			width: 40%;
			margin: 0 0 $spacing-mobile 0;
		}

		.content .commercial {
			height: auto;
			display: flex;
			align-content: center;
		}
	}
	
	.structure-1,
	.structure-2 {
		.flex.element {
			margin-bottom: $media-gap;

			@include for-tablet-portrait-up {
				&.align_right {
					width: calc(100% / 3 * 2);
					align-self: flex-end;
				}
				&:last-of-type {
					justify-content: end;

					.text {
						width: calc(100% / 3 * 2);
						display: flex;
						flex-direction: column;
						align-items: end;
					}
				}
			}
		}
	}

	.text {
		margin: 0;

		h3 {
			margin: $media-gap 0;
		}
		
		p {
			margin-bottom: $media-gap;
		}
	}
	
	video {
		width: 100%;
	}
</style>
